import { TabsProvider } from "hooks/dynamicWidgets/useTabs";
import { WidgetsProvider } from "hooks/dynamicWidgets/useWidgets";
import { WidgetsDataProvider } from "hooks/dynamicWidgets/useWidgetsData";
import allHooks from "hooks";

import { WidgetGrid } from "processhub-components-lib";
import tabBodyConfig from "config/dashboard/tabBodyConfig";

interface DynamicWidgetsProps {
  type: any;
  themeKey?: number;
}

export default function DynamicWidgets({ type, themeKey = 0 }: DynamicWidgetsProps) {
  return (
    <WidgetsProvider>
      <WidgetsDataProvider>
        <TabsProvider>
          <WidgetGrid
            key={themeKey}
            type={type}
            hooks={allHooks}
            tabBodyConfig={tabBodyConfig}
            theme="default"
          />
        </TabsProvider>
      </WidgetsDataProvider>
    </WidgetsProvider>
  );
}
